import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'noEmail',
    'hasEmail',
    'emailDisplay',
    'editForm',
    'emailInput',
    'cashoutSection',
    'saveButton',
    'feedback',
    'taxPanel',
    'taxChevron',
  ]

  static values = {
    updateUrl: String,
    csrfToken: String,
  }

  toggleTax() {
    this.taxPanelTarget.classList.toggle('open')
    this.taxChevronTarget.classList.toggle('rotate-180')
  }

  showEditForm() {
    this.editFormTarget.classList.remove('hidden')
    this.emailDisplayTarget.classList.add('hidden')
    this.emailInputTarget.focus()
  }

  cancelEdit() {
    this.editFormTarget.classList.add('hidden')
    this.emailDisplayTarget.classList.remove('hidden')
  }

  async saveEmail(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value.trim()
    if (!email) return

    this.saveButtonTarget.disabled = true
    this.saveButtonTarget.textContent = 'Saving…'
    this.clearFeedback()

    try {
      const response = await fetch(this.updateUrlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfTokenValue,
          'Accept': 'application/json',
        },
        body: JSON.stringify({ user: { paypal_email: email } }),
      })

      const data = await response.json()

      if (response.ok) {
        if (this.hasNoEmailTarget) {
          this.noEmailTarget.classList.add('hidden')
        }
        this.hasEmailTarget.classList.remove('hidden')
        this.cashoutSectionTarget.classList.remove('hidden')
        this.emailDisplayTarget.textContent = data.paypal_email
        this.emailDisplayTarget.classList.remove('hidden')
        this.editFormTarget.classList.add('hidden')
        this.showFeedback('PayPal email saved.', 'success')
      }
      else {
        this.showFeedback(data.errors?.join(', ') || 'Could not save email.', 'error')
      }
    }
    catch {
      this.showFeedback('Network error — please try again.', 'error')
    }
    finally {
      this.saveButtonTarget.disabled = false
      this.saveButtonTarget.textContent = 'Save'
    }
  }

  showFeedback(message, type) {
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.textContent = message
    this.feedbackTarget.className = type === 'success'
      ? 'text-xs mt-1 text-green-600'
      : 'text-xs mt-1 text-red-500'
    this.feedbackTarget.classList.remove('hidden')
    setTimeout(() => this.clearFeedback(), 4000)
  }

  clearFeedback() {
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.textContent = ''
    this.feedbackTarget.classList.add('hidden')
  }
}
